<template>
  <nav class="vacancy-nav">
    <!-- Main settings -->
    <h4 class="vacancy-nav_title">{{ $tr('vacancy.navigation.stages.main') }}</h4>

    <section class="vacancy-nav_section">
      <div v-for="item in menuMain" :key="item.id">
        <vacancy-navigation-item v-if="!(item.id === 'integration' && item.is_enabled === false)" :item="item" />
      </div>
    </section>

    <!-- Additional settings -->
    <h4 class="vacancy-nav_title">{{ $tr('vacancy.navigation.stages.additional') }}</h4>

    <section class="vacancy-nav_section">
      <div v-for="item in menuAdditional" :key="item.id">
        <vacancy-navigation-item :item="item" />
      </div>
    </section>

    <!-- Integrations menu -->
    <h4 v-if="menuIntegrations.length > 0" class="vacancy-nav_title">
      {{ $tr('vacancy.navigation.stages.integrations') }}
    </h4>

    <section v-if="menuIntegrations.length > 0" class="vacancy-nav_section">
      <div v-for="item in menuIntegrations" :key="item.id">
        <vacancy-navigation-item :item="item" />
      </div>
    </section>
  </nav>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import VacancyNavigationItem from './VacancyNavigationItem';

export default {
  name: 'VacancyNavigation',

  components: {
    VacancyNavigationItem
  },

  props: {
    isHiddenCountry: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState('integrations', ['integrationsInstalls']),

    ...mapGetters('vacancy_new', ['companyId']),

    ...mapGetters('company_new', ['isFeatureDisabledByTariff']),

    ...mapGetters('process', ['getProcessName']),

    ...mapGetters('vacancy_new/modules', { isModuleEnabled: 'isModuleEnabled' }),

    navigationItems() {
      const commonMenuItems = [
        {
          id: 'basic',
          path_name: 'vacancy_basic',
          visible: true,
          is_enabled: true,
          name: this.$tr('vacancy.preferences.settings.general_new'),
          is_main: true,
          icon: 'basic.svg'
        },
        {
          id: 'landing',
          path_name: 'vacancy_landing',
          visible: true,
          is_enabled: true,
          name: this.$tr('vacancy.preferences.settings.landing'),
          is_main: true,
          icon: 'landing.svg'
        },
        {
          id: 'survey',
          path_name: 'vacancy_application',
          visible: this.$store.getters['vacancy_new/modules/allow_application'],
          is_enabled: this.isModuleEnabled('survey'),
          name: this.$tr('vacancy.preferences.settings.application'),
          is_main: true,
          icon: 'survey.svg'
        },
        // {
        //   id: 'tests',
        //   path_name: 'vacancy_tests',
        //   visible: this.$store.getters['vacancy_new/modules/allow_tests'],
        //   is_enabled: this.isModuleEnabled('test'),
        //   name: this.$tr('vacancy.test.title'),
        //   is_main: true,
        //   icon: 'test.svg'
        // },
        {
          id: 'vacancy-test',
          path_name: 'vacancy-test',
          visible: this.$store.getters['vacancy_new/modules/allow_tests'],
          is_enabled: this.isModuleEnabled('test'),
          name: this.$tr('vacancy.test.title'),
          is_main: true,
          icon: 'test.svg'
        },
        {
          id: 'integration',
          path_name: 'vacancy_integration',
          visible: this.$store.getters['vacancy_new/modules/allow_integration'],
          is_enabled: this.isModuleEnabled('integration'),
          name: this.$tr('common.navigation.Integration'),
          is_main: true,
          icon: 'integration.svg'
        },
        {
          id: 'talentq',
          path_name: 'vacancy_talentq',
          is_enabled: true,
          visible: this.$store.getters['vacancy_new/modules/allow_talentq'],
          name: this.$tr('vacancy.talentq.title'),
          is_main: false,
          icon: 'talentq.svg'
        },
        {
          id: 'video',
          path_name: 'vacancy_video',
          visible: this.$store.getters['vacancy_new/modules/allow_video'],
          is_enabled: true,
          name: this.$tr('vacancy.videoInterview.title'),
          is_main: true,
          icon: 'video.svg'
        },
        {
          id: 'competencies',
          path_name: 'vacancy_competencies',
          feature: 'competences',
          visible: true,
          is_enabled: !this.isFeatureDisabledByTariff('competences'),
          name: this.$tr('common.navigation.competencies'),
          is_main: false,
          icon: 'competencies.svg'
        },
        {
          id: 'accesess',
          path_name: 'vacancy_accesses',
          feature: 'vacancy_permissions',
          visible: true,
          is_enabled: !this.isFeatureDisabledByTariff('vacancy_permissions'),
          name: this.$tr('common.navigation.accesess'),
          is_main: false,
          icon: 'accesess.svg'
        },
        {
          id: 'invitation',
          path_name: 'vacancy_invitation',
          visible: true,
          is_enabled: true,
          name: this.$tr('common.navigation.emailTemplate'),
          is_main: false,
          icon: 'invitation.svg'
        },
        {
          id: 'chatbot',
          path_name: 'vacancy-chatbot',
          feature: 'chatbot',
          visible: true,
          is_enabled: !this.isFeatureDisabledByTariff('chatbot'),
          name: this.$tr('chatbot.chatbot'),
          is_main: false,
          icon: 'chatbot.svg'
        }
      ];

      return commonMenuItems;
    },

    default() {
      const smsItem = {
        id: 'sms',
        path_name: 'vacancy_sms',
        visible: true,
        is_enabled: true,
        name: this.$tr('common.navigation.smsTemplate'),
        is_main: false,
        icon: 'sms.svg'
      };

      return this.isHiddenCountry ? this.navigationItems : [...this.navigationItems, smsItem];
    },

    menu() {
      if (this[this.getProcessName] !== undefined) {
        return this[this.getProcessName];
      } else {
        return this.default;
      }
    },

    menuMain() {
      return this.menu.filter(item => item.is_main);
    },

    menuAdditional() {
      return this.menu.filter(item => !item.is_main);
    },

    menuIntegrations() {
      let res = [];

      if (this.integrationsInstalls.length === 0) {
        return res;
      }

      res = this.integrationsInstalls.map(item => {
        return {
          id: item.clientId,
          path_name: `vacancy_${item.clientCode}`,
          visible: true,
          is_enabled: true,
          name: item.clientCode,
          is_integration: true,
          icon: `${item.clientCode}.svg`
        };
      });

      return res;
    },

    // Special Process
    schlum() {
      let result = this.default.filter(i => i.id !== 'video' && i.id !== 'competencies' && i.id !== 'tests');

      return result;
    },

    bat() {
      return [
        ...this.default,
        {
          id: 'special',
          path_name: 'vacancy_special',
          visible: true,
          name: this.$tr('vacancy.preferences.settings.special')
        }
      ];
    },

    deloitte() {
      return [
        ...this.default,
        {
          id: 'special',
          path_name: 'vacancy_special',
          visible: true,
          name: this.$tr('vacancy.preferences.settings.special')
        }
      ];
    },

    citibank() {
      return [
        ...this.default,
        {
          id: 'special',
          path_name: 'vacancy_special',
          visible: true,
          name: this.$tr('vacancy.preferences.settings.special')
        }
      ];
    },

    unilever() {
      return [
        ...this.default,
        {
          id: 'special',
          path_name: 'vacancy_special',
          visible: true,
          name: 'Unilever'
        }
      ];
    }
  },

  async mounted() {
    if (!this.isIntegrationsInstallsLoaded) {
      this.fetchIntegrationsInstalls();
    }
  },

  methods: {
    ...mapActions('integrations', ['fetchIntegrationsInstalls'])
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.vacancy-nav_section {
  margin-bottom: 12px;
}

.vacancy-nav_title {
  @include mixin-text-header;
  margin-bottom: 0.5rem;
  margin-left: 35px;
  color: $main-dark;
}
</style>
